// extracted by mini-css-extract-plugin
export default {"btnPrimary":"cqzDmAyMH","btnHeader":"cwMkM5BAq","buttonLink":"c1LWbfypF","white":"cybTkt509","action":"cTrw365HG","buttonImage":"cpSSP85yy","btnGray":"csiOrpGR7"};